import { render, staticRenderFns } from "./InsightQuestion.vue?vue&type=template&id=ae2eb4f4&scoped=true&"
import script from "./InsightQuestion.vue?vue&type=script&lang=js&"
export * from "./InsightQuestion.vue?vue&type=script&lang=js&"
import style0 from "./InsightQuestion.vue?vue&type=style&index=0&id=ae2eb4f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2eb4f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae2eb4f4')) {
      api.createRecord('ae2eb4f4', component.options)
    } else {
      api.reload('ae2eb4f4', component.options)
    }
    module.hot.accept("./InsightQuestion.vue?vue&type=template&id=ae2eb4f4&scoped=true&", function () {
      api.rerender('ae2eb4f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/Reports/InsightQuestion.vue"
export default component.exports